import { useEffect, useState } from 'react';

import { getAthenaClient } from 'components/api';

export const useSellerDisclosures = (addressToken?: string) => {
  const [sellerDisclosures, setSellerDisclosures] = useState<string | null | undefined>();

  useEffect(() => {
    if (!addressToken) {
      return;
    }
    getAthenaClient()
      .GetMarketplacePropertySellerDisclosures({ addressToken })
      .then((data) => {
        setSellerDisclosures(data?.marketplace?.property?.sellerDisclosuresDownloadUrl);
      });
  }, [addressToken]);

  return { sellerDisclosures };
};
